import { createReducer } from '../../utils';
import types from './types';
import {
    fetchNotificaitonTags,
    addNotificationTag,
    removeNotificaitonTag
} from './tag.reducer';

import {
    checkRegistration,
    checkOptedIn,
    checkSupport,
    checkPermission
} from './check.reducer';

export const initialState = {
    isPermissionDialogOpen: false,
    isReenablementDialogOpen: false,
    campaignToSubscribe: null,
    campaignNotificationTags: {},
    permissionStatus: null,
    clientChannelId: null,
    errors: [],
    registrationErrors: [],
    airshipChannelChanged: false,
    airshipRegistrationSucceeded: false
};

const SYNC_ACTION_HANDLERS = {
    [types.SHOW_PERMISSION_DIALOG]: (state) => ({
        ...state,
        isPermissionDialogOpen: true
    }),
    [types.HIDE_PERMISSION_DIALOG]: (state) => ({
        ...state,
        isPermissionDialogOpen: false
    }),
    [types.SHOW_REENABLEMENT_DIALOG]: (state) => ({
        ...state,
        isReenablementDialogOpen: true
    }),
    [types.HIDE_REENABLEMENT_DIALOG]: (state) => ({
        ...state,
        isReenablementDialogOpen: false
    }),
    [types.SET_CAMPAIGN_TO_SUBSCRIBE]: (state, action) => ({
        ...state,
        campaignToSubscribe: action.payload
    }),
    [types.RESET_CAMPAIGN_TO_SUBSCRIBE]: (state) => ({
        ...state,
        campaignToSubscribe: null
    })
};

const ASYNC_ACTION_HANDLERS = {
    ...fetchNotificaitonTags,
    ...addNotificationTag,
    ...removeNotificaitonTag,
    ...checkRegistration,
    ...checkOptedIn,
    ...checkSupport,
    ...checkPermission,

    // REGISTER
    [types.REGISTER.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),
    [types.REGISTER.SUCCESS]: (state, action) => ({
        ...state,
        clientChannelId: action.payload.channel_id,
        isLoading: false,
        registrationErrors: []
    }),
    [types.REGISTER.ERROR]: (state, action) => ({
        ...state,
        isLoading: false,
        registrationErrors: [action.payload]
    }),

    // SEND_PUSH
    [types.SEND_PUSH.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),

    [types.SEND_PUSH.SUCCESS]: (state) => ({
        ...state,
        isLoading: false,
        errors: []
    }),

    [types.SEND_PUSH.ERROR]: (state, action) => ({
        ...state,
        isLoading: false,
        errors: [action.payload]
    })
};

const ACTION_HANDLERS = {
    ...SYNC_ACTION_HANDLERS,
    ...ASYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
